import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';

import { getCashbotItemAttrs } from '../../utils/cashbotUtils';



const ItemsSummaryLineItem = ({
    message, value, cashbotDataName, isLarge, isEmphasized
}) => {
    const containerProps = {
        className: classNames('items-summary__item', {
            'items-summary__item--large': isLarge,
            'items-summary__item--emphasize': isEmphasized
        }),
        ...getCashbotItemAttrs('item-summary', cashbotDataName)
    };

    
    return (
        <div {...containerProps}>
            <span>{message}</span>
            <span>{value}</span>
        </div>
    );
};

ItemsSummaryLineItem.defaultProps = {
    isLarge: false,
    isEmphasized: false
};

ItemsSummaryLineItem.propTypes = {
    message: PropTypes.string.isRequired, 
    value: PropTypes.string.isRequired, 
    cashbotDataName: PropTypes.string.isRequired,
    isLarge: PropTypes.bool,
    isEmphasized: PropTypes.bool
};

export default ItemsSummaryLineItem;
